export const translations = {
  en: {
    // Common
    app_name: "mangoplus.ai",
    loading: "Loading...",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    search: "Search",
    active: "Active",
    inactive: "Inactive",
    status: "Status",
    actions: "Actions",
    name: "Name",
    description: "Description",
    category: "Category",
    tokens: "Tokens",
    
    // Auth
    login: "Login",
    register: "Register",
    logout: "Logout",
    email: "Email",
    password: "Password",
    full_name: "Full Name",
    login_title: "Sign In",
    register_title: "Sign Up",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    login_success: "Login successful!",
    register_success: "Registration successful!",
    login_error: "Invalid email or password",
    register_error: "Registration failed. Please try again.",
    demo_account: "Demo Admin Account:",
    
    // Navigation
    nav_dashboard: "Dashboard",
    nav_generate: "Generate Photo",
    nav_gallery: "Gallery",
    nav_purchase: "Buy Credits",
    nav_packages: "Packages",
    nav_users: "Users",
    nav_categories: "Categories",
    nav_backgrounds: "Backgrounds",
    nav_models: "Model Artists",
    nav_styles: "Artist Styles",
    nav_settings: "Settings",
    
    // Landing Page
    hero_title: "Professional Product Photos in Seconds",
    hero_subtitle: "Transform ordinary product photos into studio-quality images with AI technology. Perfect for e-commerce, social media, and product catalogs.",
    hero_cta: "Start Generating",
    hero_demo: "See Demo",
    powered_by_ai: "Powered by AI",
    how_it_works: "How It Works",
    how_it_works_subtitle: "Just 4 easy steps to get professional product photos",
    step_upload: "Upload Product",
    step_upload_desc: "Upload your product photos easily. Supports various image formats.",
    step_style: "Choose Style",
    step_style_desc: "Select background, model, and lighting style as needed.",
    step_generate: "AI Generate",
    step_generate_desc: "Let AI create professional product photos in seconds.",
    step_download: "Download & Share",
    step_download_desc: "Download results or share directly to social media.",
    features_title: "Key Features",
    ai_background: "AI Background Generation",
    ai_background_desc: "Choose from hundreds of professional backgrounds or let AI create custom backgrounds for your needs.",
    virtual_model: "Virtual Model",
    virtual_model_desc: "Add virtual models for fashion or lifestyle product photos.",
    studio_lighting: "Studio Lighting",
    studio_lighting_desc: "Set professional lighting for perfect photos.",
    export_hd: "Export HD & 4K",
    export_hd_desc: "Download results in various resolutions, from social media to high-quality print.",
    choose_package: "Choose Package",
    choose_package_subtitle: "Pay as you need. No monthly subscription.",
    most_popular: "Most Popular",
    cta_title: "Ready to Improve Your Product Photo Quality?",
    cta_subtitle: "Register now and get 10 free credits to try all features.",
    register_free: "Register Free",
    
    // Dashboard
    welcome: "Welcome",
    dashboard_subtitle: "Start creating professional product photos with AI",
    credits_remaining: "Credits Remaining",
    total_images: "Total Images",
    generate_new: "Generate New Photo",
    recent_images: "Recent Images",
    view_all: "View All",
    no_images: "No images yet. Start generating now!",
    first_generate: "Generate First Photo",
    
    // Generate Page
    select_photo_type: "Select Photo Type",
    single_product: "Single Product",
    single_product_desc: "Product photo with custom background without model",
    with_model: "With Model",
    with_model_desc: "Product photo with virtual model and pose style",
    select_category: "Select Category",
    no_categories: "No categories yet. Contact admin to add.",
    upload_product: "Upload Product Photos",
    drag_drop: "Drag & drop or click to upload",
    file_limit: "PNG, JPG up to 10MB",
    select_background: "Select Background",
    no_backgrounds: "No backgrounds for this category.",
    model_style: "Model & Style",
    no_model_mode: "Single Product mode doesn't use model",
    continue_next: "Continue to next step to generate",
    select_model: "Select Model Artist",
    no_models: "No models available",
    select_style: "Select Artist Style",
    no_styles: "No styles available for this category",
    tokens_needed: "Tokens needed",
    back: "Back",
    next: "Next",
    generate: "Generate",
    generating: "Generating...",
    insufficient_credits: "Insufficient credits. Please buy credits first.",
    generate_success: "Image generated successfully!",
    generate_error: "Failed to generate image",
    
    // Gallery
    gallery: "Gallery",
    gallery_title: "Gallery",
    gallery_subtitle: "All your generated results",
    images: "images",
    images_count: "images",
    download: "Download",
    share: "Share",
    image_detail: "Image Detail",
    type: "Type",
    tokens_used: "Tokens Used",
    ai_provider: "AI Provider",
    delete_confirm: "Are you sure you want to delete this image?",
    delete_success: "Image deleted successfully",
    gallery_empty: "Gallery Empty",
    gallery_empty_hint: "Start generating photos to fill your gallery",
    gallery_empty_desc: "Start generating photos to fill your gallery",
    gallery_load_error: "Failed to load gallery",
    image_deleted: "Image deleted successfully",
    delete_error: "Failed to delete image",
    download_started: "Download started",
    download_error: "Failed to download image",
    link_copied: "Link copied to clipboard",
    
    // Purchase
    buy_credits: "Buy Credits",
    buy_credits_subtitle: "Choose a package that suits your needs",
    buy_credits_topup: "Top up credits to generate more",
    current_credits: "Current credits",
    credits: "Credits",
    buy_now: "Buy Now",
    processing: "Processing...",
    payment_info: "Payment Information",
    payment_info_1: "Payments processed through Mayar Payment Gateway",
    payment_info_2: "Supports Bank Transfer, E-Wallet, and QRIS",
    payment_info_3: "Credits will be added automatically after successful payment",
    payment_info_4: "Contact support if you have payment issues",
    
    // Admin
    admin_dashboard: "Admin Dashboard",
    admin_subtitle: "Manage mangoplus.ai application",
    total_users: "Total Users",
    total_transactions: "Total Transactions",
    manage_packages: "Manage Packages",
    manage_users: "Manage Users",
    manage_backgrounds: "Manage Backgrounds",
    
    // Admin Packages
    packages_title: "Manage Packages",
    packages_subtitle: "Set packages and credit prices",
    add_package: "Add Package",
    package_name: "Package Name",
    price: "Price",
    price_idr: "Price (IDR)",
    edit_package: "Edit Package",
    add_new_package: "Add New Package",
    package_saved: "Package saved successfully",
    package_deleted: "Package deleted successfully",
    
    // Admin Users
    users_title: "Manage Users",
    users_subtitle: "View and manage users",
    search_users: "Search name or email...",
    role: "Role",
    edit_user: "Edit User",
    user_saved: "User saved successfully",
    user_deleted: "User deleted successfully",
    
    // Admin Categories
    categories_title: "Manage Categories",
    categories_subtitle: "Set product categories",
    add_category: "Add Category",
    category_name: "Category Name",
    edit_category: "Edit Category",
    add_new_category: "Add New Category",
    category_saved: "Category saved successfully",
    category_deleted: "Category deleted successfully",
    
    // Admin Backgrounds
    backgrounds_title: "Manage Backgrounds",
    backgrounds_subtitle: "Set backgrounds for photo generation",
    add_background: "Add Background",
    preview: "Preview",
    prompt: "Prompt",
    ai_prompt: "AI Prompt",
    thumbnail: "Thumbnail",
    edit_background: "Edit Background",
    add_new_background: "Add New Background",
    background_saved: "Background saved successfully",
    background_deleted: "Background deleted successfully",
    upload_thumbnail: "Please upload thumbnail first",
    select_category_first: "Please select category",
    token_cost: "Token Cost",
    
    // Admin Models
    models_title: "Manage Model Artists",
    models_subtitle: "Set virtual models for photo generation",
    add_model: "Add Model",
    references: "References",
    model_name: "Model Name",
    reference_image: "Reference Image",
    reference_required: "Reference Image 1 (Required)",
    reference_optional: "Reference Image (Optional)",
    edit_model: "Edit Model",
    add_new_model: "Add New Model",
    model_saved: "Model saved successfully",
    model_deleted: "Model deleted successfully",
    upload_reference: "Please upload at least 1 reference image",
    
    // Admin Styles
    styles_title: "Manage Artist Styles",
    styles_subtitle: "Set styles/poses for model artists",
    add_style: "Add Style",
    style_name: "Style Name",
    style_example: "Example: Sitting with product",
    edit_style: "Edit Style",
    add_new_style: "Add New Style",
    style_saved: "Style saved successfully",
    style_deleted: "Style deleted successfully",
    
    // Admin Settings
    settings_title: "Settings",
    settings_subtitle: "Application configuration",
    ai_provider_setting: "AI Provider",
    ai_provider_desc: "Select provider for image generation",
    nano_banana: "Gemini Image Generation",
    bytedance: "Bytedance Seedream 4.5",
    tokens_per_gen: "Tokens per Generate",
    tokens_per_gen_desc: "Number of credits deducted per generated image",
    webhook_title: "Mayar Webhook",
    webhook_subtitle: "Payment callback configuration",
    webhook_url: "Webhook URL (set in Mayar)",
    webhook_copy: "Copy this URL to Mayar dashboard to receive payment notifications",
    copy: "Copy",
    url_copied: "URL copied to clipboard",
    settings_saved: "Settings saved successfully",
    
    // Token Breakdown
    token_breakdown: "Token Breakdown",
    background_tokens: "Background",
    model_tokens: "Model",
    style_tokens: "Style",
    total_tokens: "Total",
  },
  
  id: {
    // Common
    app_name: "mangoplus.ai",
    loading: "Memuat...",
    save: "Simpan",
    cancel: "Batal",
    delete: "Hapus",
    edit: "Edit",
    add: "Tambah",
    search: "Cari",
    active: "Aktif",
    inactive: "Tidak Aktif",
    status: "Status",
    actions: "Aksi",
    name: "Nama",
    description: "Deskripsi",
    category: "Kategori",
    tokens: "Token",
    
    // Auth
    login: "Masuk",
    register: "Daftar",
    logout: "Keluar",
    email: "Email",
    password: "Password",
    full_name: "Nama Lengkap",
    login_title: "Masuk",
    register_title: "Daftar",
    no_account: "Belum punya akun?",
    have_account: "Sudah punya akun?",
    login_success: "Login berhasil!",
    register_success: "Registrasi berhasil!",
    login_error: "Email atau password salah",
    register_error: "Registrasi gagal. Coba lagi.",
    demo_account: "Demo Admin Account:",
    
    // Navigation
    nav_dashboard: "Dashboard",
    nav_generate: "Generate Foto",
    nav_gallery: "Gallery",
    nav_purchase: "Beli Credit",
    nav_packages: "Paket",
    nav_users: "Users",
    nav_categories: "Kategori",
    nav_backgrounds: "Background",
    nav_models: "Model Artis",
    nav_styles: "Gaya Artis",
    nav_settings: "Settings",
    
    // Landing Page
    hero_title: "Foto Produk Profesional dalam Hitungan Detik",
    hero_subtitle: "Transformasi foto produk biasa menjadi gambar berkualitas studio dengan teknologi AI. Cocok untuk e-commerce, sosial media, dan katalog produk.",
    hero_cta: "Mulai Generate",
    hero_demo: "Lihat Demo",
    powered_by_ai: "Powered by AI",
    how_it_works: "Cara Kerja",
    how_it_works_subtitle: "Hanya 4 langkah mudah untuk mendapatkan foto produk profesional",
    step_upload: "Upload Product",
    step_upload_desc: "Upload foto produk Anda dengan mudah. Mendukung berbagai format gambar.",
    step_style: "Pilih Gaya",
    step_style_desc: "Pilih background, model, dan gaya pencahayaan sesuai kebutuhan.",
    step_generate: "AI Generate",
    step_generate_desc: "Biarkan AI menciptakan foto produk profesional dalam hitungan detik.",
    step_download: "Download & Share",
    step_download_desc: "Unduh hasil atau bagikan langsung ke media sosial.",
    features_title: "Fitur Unggulan",
    ai_background: "AI Background Generation",
    ai_background_desc: "Pilih dari ratusan background profesional atau biarkan AI membuat background custom sesuai kebutuhan Anda.",
    virtual_model: "Model Virtual",
    virtual_model_desc: "Tambahkan model virtual untuk foto fashion atau lifestyle product.",
    studio_lighting: "Studio Lighting",
    studio_lighting_desc: "Atur pencahayaan profesional untuk hasil foto yang sempurna.",
    export_hd: "Export HD & 4K",
    export_hd_desc: "Download hasil dalam berbagai resolusi, dari sosial media hingga cetak berkualitas tinggi.",
    choose_package: "Pilih Paket",
    choose_package_subtitle: "Bayar sesuai kebutuhan. Tanpa langganan bulanan.",
    most_popular: "Paling Populer",
    cta_title: "Siap Meningkatkan Kualitas Foto Produk?",
    cta_subtitle: "Daftar sekarang dan dapatkan 10 credits gratis untuk mencoba semua fitur.",
    register_free: "Daftar Gratis",
    
    // Dashboard
    welcome: "Selamat Datang",
    dashboard_subtitle: "Mulai buat foto produk profesional dengan AI",
    credits_remaining: "Credits Tersisa",
    total_images: "Total Gambar",
    generate_new: "Generate Foto Baru",
    recent_images: "Gambar Terbaru",
    view_all: "Lihat Semua",
    no_images: "Belum ada gambar. Mulai generate sekarang!",
    first_generate: "Generate Foto Pertama",
    
    // Generate Page
    select_photo_type: "Pilih Jenis Foto",
    single_product: "Single Product",
    single_product_desc: "Foto produk dengan background custom tanpa model",
    with_model: "Dengan Model",
    with_model_desc: "Foto produk dengan model virtual dan gaya pose",
    select_category: "Pilih Kategori",
    no_categories: "Belum ada kategori. Hubungi admin untuk menambahkan.",
    upload_product: "Upload Foto Produk",
    drag_drop: "Drag & drop atau klik untuk upload",
    file_limit: "PNG, JPG hingga 10MB",
    select_background: "Pilih Background",
    no_backgrounds: "Belum ada background untuk kategori ini.",
    model_style: "Model & Gaya",
    no_model_mode: "Mode Single Product tidak menggunakan model",
    continue_next: "Lanjutkan ke langkah berikutnya untuk generate",
    select_model: "Pilih Model Artis",
    no_models: "Belum ada model tersedia",
    select_style: "Pilih Gaya Artis",
    no_styles: "Belum ada gaya tersedia untuk kategori ini",
    tokens_needed: "Token dibutuhkan",
    back: "Kembali",
    next: "Lanjut",
    generate: "Generate",
    generating: "Generating...",
    insufficient_credits: "Credits tidak cukup. Silakan beli credits terlebih dahulu.",
    generate_success: "Gambar berhasil digenerate!",
    generate_error: "Gagal generate gambar",
    
    // Gallery
    gallery: "Gallery",
    gallery_title: "Gallery",
    gallery_subtitle: "Semua hasil generate Anda",
    images: "gambar",
    images_count: "gambar",
    download: "Download",
    share: "Share",
    image_detail: "Detail Gambar",
    type: "Tipe",
    tokens_used: "Token Digunakan",
    ai_provider: "AI Provider",
    delete_confirm: "Yakin ingin menghapus gambar ini?",
    delete_success: "Gambar berhasil dihapus",
    gallery_empty: "Gallery Kosong",
    gallery_empty_hint: "Mulai generate foto untuk mengisi gallery Anda",
    gallery_empty_desc: "Mulai generate foto untuk mengisi gallery Anda",
    gallery_load_error: "Gagal memuat gallery",
    image_deleted: "Gambar berhasil dihapus",
    delete_error: "Gagal menghapus gambar",
    download_started: "Download dimulai",
    download_error: "Gagal download gambar",
    link_copied: "Link disalin ke clipboard",
    
    // Purchase
    buy_credits: "Beli Credits",
    buy_credits_subtitle: "Pilih paket yang sesuai dengan kebutuhan Anda",
    buy_credits_topup: "Top up credits untuk generate lebih banyak",
    current_credits: "Credits saat ini",
    credits: "Credits",
    buy_now: "Beli Sekarang",
    processing: "Memproses...",
    payment_info: "Informasi Pembayaran",
    payment_info_1: "Pembayaran diproses melalui Mayar Payment Gateway",
    payment_info_2: "Mendukung Transfer Bank, E-Wallet, dan QRIS",
    payment_info_3: "Credits akan otomatis ditambahkan setelah pembayaran sukses",
    payment_info_4: "Hubungi support jika ada masalah pembayaran",
    
    // Admin
    admin_dashboard: "Admin Dashboard",
    admin_subtitle: "Kelola aplikasi mangoplus.ai",
    total_users: "Total Users",
    total_transactions: "Total Transaksi",
    manage_packages: "Kelola Paket",
    manage_users: "Kelola Users",
    manage_backgrounds: "Kelola Background",
    
    // Admin Packages
    packages_title: "Kelola Paket",
    packages_subtitle: "Atur paket dan harga credits",
    add_package: "Tambah Paket",
    package_name: "Nama Paket",
    price: "Harga",
    price_idr: "Harga (IDR)",
    edit_package: "Edit Paket",
    add_new_package: "Tambah Paket Baru",
    package_saved: "Paket berhasil disimpan",
    package_deleted: "Paket berhasil dihapus",
    
    // Admin Users
    users_title: "Kelola Users",
    users_subtitle: "Lihat dan kelola pengguna",
    search_users: "Cari nama atau email...",
    role: "Role",
    edit_user: "Edit User",
    user_saved: "User berhasil disimpan",
    user_deleted: "User berhasil dihapus",
    
    // Admin Categories
    categories_title: "Kelola Kategori",
    categories_subtitle: "Atur kategori produk",
    add_category: "Tambah Kategori",
    category_name: "Nama Kategori",
    edit_category: "Edit Kategori",
    add_new_category: "Tambah Kategori Baru",
    category_saved: "Kategori berhasil disimpan",
    category_deleted: "Kategori berhasil dihapus",
    
    // Admin Backgrounds
    backgrounds_title: "Kelola Background",
    backgrounds_subtitle: "Atur background untuk generate foto",
    add_background: "Tambah Background",
    preview: "Preview",
    prompt: "Prompt",
    ai_prompt: "Prompt AI",
    thumbnail: "Thumbnail",
    edit_background: "Edit Background",
    add_new_background: "Tambah Background Baru",
    background_saved: "Background berhasil disimpan",
    background_deleted: "Background berhasil dihapus",
    upload_thumbnail: "Silakan upload thumbnail terlebih dahulu",
    select_category_first: "Silakan pilih kategori",
    token_cost: "Biaya Token",
    
    // Admin Models
    models_title: "Kelola Model Artis",
    models_subtitle: "Atur model virtual untuk generate foto",
    add_model: "Tambah Model",
    references: "Referensi",
    model_name: "Nama Model",
    reference_image: "Foto Referensi",
    reference_required: "Foto Referensi 1 (Wajib)",
    reference_optional: "Foto Referensi (Opsional)",
    edit_model: "Edit Model",
    add_new_model: "Tambah Model Baru",
    model_saved: "Model berhasil disimpan",
    model_deleted: "Model berhasil dihapus",
    upload_reference: "Silakan upload minimal 1 foto referensi",
    
    // Admin Styles
    styles_title: "Kelola Gaya Artis",
    styles_subtitle: "Atur gaya/pose untuk model artis",
    add_style: "Tambah Gaya",
    style_name: "Nama Gaya",
    style_example: "Contoh: Duduk dengan produk",
    edit_style: "Edit Gaya",
    add_new_style: "Tambah Gaya Baru",
    style_saved: "Gaya berhasil disimpan",
    style_deleted: "Gaya berhasil dihapus",
    
    // Admin Settings
    settings_title: "Settings",
    settings_subtitle: "Konfigurasi aplikasi",
    ai_provider_setting: "AI Provider",
    ai_provider_desc: "Pilih provider untuk generate gambar",
    nano_banana: "Gemini Image Generation",
    bytedance: "Bytedance Seedream 4.5",
    tokens_per_gen: "Token per Generate",
    tokens_per_gen_desc: "Jumlah credit yang dipotong per gambar yang digenerate",
    webhook_title: "Mayar Webhook",
    webhook_subtitle: "Konfigurasi callback pembayaran",
    webhook_url: "Webhook URL (untuk diset di Mayar)",
    webhook_copy: "Salin URL ini ke dashboard Mayar untuk menerima notifikasi pembayaran",
    copy: "Copy",
    url_copied: "URL disalin ke clipboard",
    settings_saved: "Settings berhasil disimpan",
    
    // Token Breakdown
    token_breakdown: "Rincian Token",
    background_tokens: "Background",
    model_tokens: "Model",
    style_tokens: "Gaya",
    total_tokens: "Total",
  }
};

export const getTranslation = (lang, key) => {
  return translations[lang]?.[key] || translations['en'][key] || key;
};
